// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/FileInfo.scss
// module id = 21
// module chunks = 0